import axios from 'axios'
import repo from './repository'

const login = async (username, password) => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users/login`
    const body = { username, password }
    const r = await axios.post(url, body).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    // Do something
  }
  return rslt
}

const createGuest = async (username, password) => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users/guest`
    const body = {
      username: username,
      password: password,
      secret_key: '1234567890'
    }
    const r = await axios.post(url, body).then(m => m.data)
    console.log(r)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    // Do something
  }
}

const loadMe = async () => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users/me`
    const r = await axios.get(url, { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` } }).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    // Do something
  }
}

const createSubscription = async (user, paymentMethodId, priceId) => {
  let rslt = null
  try {
    const body = {
      user: { id: user.id, email: user.email },
      paymentMethodId: paymentMethodId,
      priceId: priceId
    }

    const url = `${repo.endpoint}/users/create-subscription`
    const r = await axios.post(url, body).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    // Do something
  }
}

const retrieveUserByUsername = async (username) => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users?username=${username}`
    const r = await axios.get(url).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    console.log(err)
  }
}

const updateUser = async (userId, body) => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users/${userId}`
    const r = await axios.post(url, body).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    console.log(err)
  }
}

const loadUserByUsername = async (username) => {
  let rslt = null
  try {
    const url = `${repo.endpoint}/users?username=${username}`
    const r = await axios.get(url).then(m => m.data)
    if (r.code === '000') {
      rslt = r.data
    }
    return rslt
  } catch (err) {
    console.log(err)
  }
}

export {
  login, createGuest, loadMe, createSubscription, retrieveUserByUsername, updateUser, loadUserByUsername
}
